import React from "react";
import { Typography } from "@mui/material";
import { GlobalModal } from "../../../components/GlobalModal";
import ReportBrowser from "./ReportBrowser";

interface ReportPreviewModalProps {
  open: boolean;
  onClose: () => void;
  caseId?: number;
  reportExists?: boolean;
}

/**
 * Opens the report browser (file tree + text/image preview) for a single case
 * in a modal, so users can peek inside a report's files/screenshots without
 * navigating to the case page or downloading the zip.
 */
const ReportPreviewModal: React.FC<ReportPreviewModalProps> = ({
  open,
  onClose,
  caseId,
  reportExists = true,
}) => (
  <GlobalModal
    open={open}
    onClose={onClose}
    title={caseId != null ? `Report preview — case ${caseId}` : "Report preview"}
    height="auto"
  >
    <Typography color="text.secondary" sx={{ fontSize: "0.85rem", mb: 2, mt: -1 }}>
      Browse the files inside this case's report — open logs, JSON or screenshots
      without downloading the full archive.
    </Typography>
    {open && caseId != null && (
      <ReportBrowser
        caseId={caseId}
        reportExists={reportExists}
        autoLoad
        framed={false}
      />
    )}
  </GlobalModal>
);

export default ReportPreviewModal;
